var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgBgFeat2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 463,
    height: 419,
    viewBox: "0 0 463 419",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.043-144c37.966 90.503 80.615 304.798-52.52 437.958C235.387 427.117 54.034 424.12-20 405.978",
    stroke: "#20FFC3",
    strokeWidth: 8,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.5,
    strokeDasharray: "0,0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBgFeat2);
export default __webpack_public_path__ + "static/media/imgBgFeat2.8906fe12c3e5143711748e2e4ebdfe8c.svg";
export { ForwardRef as ReactComponent };